<template>
  <v-row no-gutters>
    <v-col cols="auto" class="pa-4">
      <span v-html="parsedInfoContent" style="text-align: left"></span>
    </v-col>
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify';
import { unescape } from 'lodash';

export default {
  name: 'InformationMap',
  computed: {
    infoContent: get('admin/settingsValues@info_module_content'),
    parsedInfoContent() {
      return unescape(this.infoContent);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep img,
::v-deep iframe {
  max-width: 100%;
}
</style>
